import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "LA VISION",
    text: "Nous ne suivons pas les tendances, nous les sabotons. TWELVE naît de la nuit urbaine : des vêtements pensés comme une armure douce pour celles et ceux qui avancent contre le courant.",
    image: "https://images.unsplash.com/photo-1672685196648-168d297223ba?auto=format&fit=crop&w=800&q=80",
  },
  {
    num: "02",
    title: "LE TEXTILE",
    text: "Coton 500 GSM, ripstop imperméable, cuir italien. Chaque matière est choisie pour survivre à la ville — et à ses hivers. Zéro compromis, zéro greenwashing.",
    image: "https://images.unsplash.com/photo-1658043521335-998c9fae1a03?auto=format&fit=crop&w=800&q=80",
  },
  {
    num: "03",
    title: "L'ATTITUDE",
    text: "Des drops limités, numérotés, jamais réédités. Quand c'est parti, c'est parti. La rareté n'est pas un argument marketing : c'est notre contrat avec vous.",
    image: "https://images.unsplash.com/photo-1552346154-21d32810aba3?auto=format&fit=crop&w=800&q=80",
  },
];

export const Manifesto = () => (
  <section id="manifeste" data-testid="manifesto-chapters" className="py-24 lg:py-32 border-t border-white/10 relative">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-blood mb-4">[ Le Manifeste ]</p>
        <h2 className="font-syne font-extrabold uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-none mb-16 lg:mb-24">
          Trois règles.<br />
          <span className="text-outline">Aucune exception.</span>
        </h2>
      </Reveal>
      <div className="space-y-20 lg:space-y-28">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={0.05}>
            <div className={`grid lg:grid-cols-12 gap-8 items-center ${i % 2 === 1 ? "" : ""}`}>
              <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2 lg:col-start-8" : ""}`}>
                <div className="relative clip-frame overflow-hidden border border-white/10 group">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="w-full h-72 lg:h-96 object-cover grayscale-[35%] transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/60 to-transparent" />
                </div>
              </div>
              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"}`}>
                <span className="font-mono text-blood text-sm tracking-[0.3em]">[{c.num} /</span>
                <h3 className="font-syne font-extrabold uppercase tracking-tighter text-3xl sm:text-4xl mt-2 mb-6">
                  {c.title}<span className="text-blood"> ]</span>
                </h3>
                <p className="text-smoke leading-relaxed max-w-lg">{c.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
